/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionStartWindow = Prefab.createWindow((mission) => Merge2MissionHelper.getBundleName(mission.logic.period), "merge2mission_start_window_prefab_json");

Merge2MissionStartWindow.WINDOW_NAME = "merge2missionstartwindow";
